import { configureStore } from '@reduxjs/toolkit';

import autoPersonalFormReducer from 'reducers/autoPersonalFormReducer';
import specialtyFormReducer from 'reducers/specialtyFormReducer';
import commercialFormReducer from 'reducers/commercialFormReducer';
import homePersonalFormReducer from 'reducers/homePersonalFormReducer';
import featureFlagsReducer from 'reducers/featureFlagsReducer';
import legacyAutoFormReducer from 'reducers/legacyAutoFormReducer';
import lifeInsuranceFormReducer from 'reducers/lifeInsuranceFormReducer';
import baraReducer from 'reducers/baraReducer';

import personalFormMiddleware from 'middlewares/personalFormMiddleware';

const store = configureStore({
  reducer: {
    autoPersonalForm: autoPersonalFormReducer,
    specialtyForm: specialtyFormReducer,
    commercialForm: commercialFormReducer,
    homePersonalForm: homePersonalFormReducer,
    featureFlags: featureFlagsReducer,
    legacyAutoForm: legacyAutoFormReducer,
    lifeInsuranceForm: lifeInsuranceFormReducer,
    bara: baraReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(personalFormMiddleware),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export default store;
